import { Helmet } from 'react-helmet-async';

const SEOConfig = () => {
  const isHomolog = window.location.hostname.includes('homolog');
  const isOldPath = window.location.pathname.startsWith('/old');
  
  return (
    <Helmet>
      {(isHomolog || isOldPath) && (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {!isHomolog && !isOldPath && (
        <meta name="robots" content="index, follow" />
      )}
    </Helmet>
  );
};

export default SEOConfig;